import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { beltHex } from "../lib/beltColor";

// Mur des ceintures — ceintures décernées ce mois (Mon matin) + texte prêt pour les réseaux.
export function BeltWallCard() {
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/progression/belt-wall").then((r) => setData(r.data)).catch(() => setData(null)); }, []);
  if (!data) return null;

  const copy = async () => {
    try { await navigator.clipboard.writeText(data.social_text); toast.success("Message copié — colle-le sur Facebook / Instagram 🎉"); }
    catch { toast.error("Copie impossible"); }
  };

  return (
    <div className="rounded-2xl border border-amber-500/30 bg-amber-500/5 p-5 mb-5" data-testid="belt-wall-card">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <div className="text-[10px] tracking-[0.3em] text-amber-400 uppercase">Mur des ceintures</div>
          <h3 className="text-lg font-bold text-zinc-100 mt-0.5">🥋 {data.count} ceinture{data.count > 1 ? "s" : ""} décernée{data.count > 1 ? "s" : ""} en {data.label}</h3>
        </div>
        <div className="flex gap-2">
          {data.count > 0 && (
            <button onClick={copy} data-testid="belt-wall-copy-btn"
              className="px-3 py-1.5 rounded-lg bg-amber-600 hover:bg-amber-500 text-black text-xs font-bold">📣 Copier pour les réseaux</button>
          )}
          <Link to="/app/carnet-progression" className="px-3 py-1.5 rounded-lg border border-zinc-700 text-zinc-300 hover:text-white text-xs" data-testid="belt-wall-link">Carnets →</Link>
        </div>
      </div>
      {data.count === 0 ? (
        <p className="text-sm text-zinc-500 mt-3">Aucune ceinture décernée ce mois-ci. Décerne-en une depuis le carnet d'un élève (« 🎉 Décerner la ceinture »).</p>
      ) : (
        <ul className="mt-3 grid gap-2 sm:grid-cols-2 xl:grid-cols-3">
          {data.promotions.map((p) => (
            <li key={p.id} className="flex items-center gap-3 rounded-lg bg-zinc-900/70 border border-zinc-800 px-3 py-2" data-testid={`belt-wall-row-${p.id}`}>
              <span className="w-4 h-4 rounded-full border border-white/30 shrink-0" style={{ backgroundColor: beltHex(p.new_belt) }} />
              <div className="min-w-0 flex-1">
                <div className="text-sm font-semibold text-zinc-100 truncate">{p.student_name}</div>
                <div className="text-[11px] text-zinc-400">
                  {p.old_belt ? `${p.old_belt} → ` : ""}<span className="text-amber-300 font-semibold">{p.new_belt}</span>
                  {p.discipline ? ` · ${p.discipline.replace(/_/g, " ")}` : ""} · {new Date(p.at).toLocaleDateString("fr-CA")}
                  {p.sms_sent ? " · 📱 SMS ✓" : ""}
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
